export default "__VITE_PUBLIC_ASSET__17954ef3__"